/* eslint-disable jsx-a11y/label-has-associated-control,react/no-unused-prop-types */
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Slider } from '@components/atoms/Slider';

import { IAttributeFieldProps } from './types';
import * as S from './styles';

interface ISliderMessageProps {
  attribute: { getMessage?: (value: number | string) => string };
}

export const AttributeFieldSlider: React.FC<
  IAttributeFieldProps & ISliderMessageProps
> = ({ attribute }) => {
  const edgeValues = useMemo(() => {
    const sorted = attribute.values
      .slice()
      .sort((a, b) => parseInt(a.slug, 10) - parseInt(b.slug, 10));

    const max = parseInt(sorted[sorted.length - 1].slug, 10) / 10;
    const min = parseInt(sorted[0].slug, 10) / 10;

    return {
      max,
      min,
    };
  }, [attribute]);

  const { control, getValues } = useFormContext();

  const containsTop = (obj: Record<string, any>): boolean => 
    Object.values(obj).some(value => 
        typeof value === 'string' && value.includes('top')
    );

  return (
    <S.Slider>
      <Controller
        name={attribute.attribute.slug}
        control={control}
        render={({ field: { onChange, value } }) => (
          <S.SliderColumn>
            <S.SliderRow>
              <S.SliderEdgeValue
                className="min"
                active={edgeValues.min === value / 10}
              >
                {edgeValues.min} cm
              </S.SliderEdgeValue>
              <S.SliderEdgeValue
                className="max"
                active={edgeValues.max === value / 10}
              >
                {edgeValues.max} cm
              </S.SliderEdgeValue>
              <Slider
                values={attribute.values}
                onChange={onChange}
                value={value}
                compactView={!containsTop(getValues())}
              />
            </S.SliderRow>
          </S.SliderColumn>
        )}
      />
    </S.Slider>
  );
};
